<crnt-form-control>
  <crnt-form-control-label slot="label">
    <label [for]="control().id">
      {{ control().options.label }}
      @if (showOptional) {
        <crnt-form-control-label-indicator>
          (niet verplicht)
        </crnt-form-control-label-indicator>
      }
    </label>
  </crnt-form-control-label>
  @if (control().options.helpText) {
    <crnt-form-control-help-text slot="help">
      {{ control().options.helpText }}
    </crnt-form-control-help-text>
  }

  @if (control().hasError()) {
    <rfa-errors slot="validation" [control]="control()"></rfa-errors>
  }
  <crnt-text-input>
    @let prefix = control().options.prefix;
    @let suffix = control().options.suffix;

    @if (prefix) {
      <rfa-prefix-suffix
        slot="leading"
        [prefixSuffix]="prefix"
      ></rfa-prefix-suffix>
    }

    <input
      type="number"
      [id]="control().id"
      [formControl]="control()"
      [wlAutomationId]="control().options.dataAutomationId"
      [name]="autocompleteId"
      [autocomplete]="autocompleteId"
      [wlTrackFieldfocus]="focusChangeTrackConfig()"
    />

    @if (suffix) {
      <rfa-prefix-suffix
        slot="trailing"
        [prefixSuffix]="suffix"
      ></rfa-prefix-suffix>
    }
  </crnt-text-input>
</crnt-form-control>
